import { HERO_PORTRAIT_MAX_WIDTH } from "~/constants/heroPortrait"

export interface PixelCrop {
  x: number
  y: number
  width: number
  height: number
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener("load", () => resolve(image))
    image.addEventListener("error", () => reject(new Error("Failed to load image for crop")))
    image.src = src
  })
}

/**
 * Crops an image to the given pixel area and returns a JPEG File scaled to maxWidth.
 */
export async function cropImageFile(
  imageSrc: string,
  pixelCrop: PixelCrop,
  fileName: string,
  maxWidth = HERO_PORTRAIT_MAX_WIDTH,
): Promise<File> {
  const image = await loadImage(imageSrc)
  const scale = Math.min(1, maxWidth / pixelCrop.width)
  const outputWidth = Math.round(pixelCrop.width * scale)
  const outputHeight = Math.round(pixelCrop.height * scale)

  const canvas = document.createElement("canvas")
  canvas.width = outputWidth
  canvas.height = outputHeight

  const ctx = canvas.getContext("2d")
  if (!ctx) throw new Error("Canvas not supported")

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputWidth,
    outputHeight,
  )

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (result) => {
        if (result) resolve(result)
        else reject(new Error("Failed to export cropped image"))
      },
      "image/jpeg",
      0.92,
    )
  })

  const baseName = fileName.replace(/\.[^.]+$/, "") || "dog-photo"
  return new File([blob], `${baseName}.jpg`, { type: "image/jpeg" })
}
